import cs from './cs';

const languages = {
  cs,
};

export default languages;
